export default {
  setShowInstructions(state, bool) {
    state.showInstructions = bool
  }
}
